<template>
    <van-tabs v-model="active" id="recordPage">

        <van-tab title="余额充值记录" v-if="$store.state.isHeadquarterAppid=='true'">
            <div class="recordPanel">
                <div v-if="balanceRechargeRocordList.length > 0">
                    <div v-for="item in balanceRechargeRocordList" :key="item.orderNo" class="records">
                        
                        <ul class="rechargeInfo">
                            <li>
                                <label>付款单号：</label>
                                <span>{{ item.orderNo }}</span>
                            </li>
                            <li>
                                <label>付款金额：</label>
                                <span >{{money_format(item.amount/100, 2, '.', ',')}}元</span>
                            </li>
                            
                            <li>
                                <label>赠送金额：</label>
                                <span>{{money_format(item.giftBalance/100 , 2, '.', ',') }}元</span>
                            </li>
                            <li>
                                <label>付款时间：</label>
                                <span>{{ item.createTime }}</span>
                            </li>
                        </ul>     
                    </div>
                    <div class="tips">没有更多了哦</div>
                </div>
                <div v-else class="nodata">
                    <img src="@/assets/nodata.png" alt="">
                    <span>暂无数据</span>
                </div>
            </div>
        </van-tab>



        <van-tab title="流量订购记录">
            <div class="recordPanel">
                <div v-if="rechargeRocordList.length > 0">
                    <div v-for="item in rechargeRocordList" :key="item.id" class="records">
                        <h4>
                            <span>{{item.packageName}}</span>
                            <span class="money">{{item.priceRmb}}元</span>
                        </h4>
                        <ul class="rechargeInfo">
                            <li>
                                <label>关联单号：</label>
                                <span>{{ item.orderNo }}</span>
                            </li>
                            <li>
                                <label>生效时间：</label>
                                <span>{{ item.isNextMonthName }}</span>
                            </li>
                            <li>
                                <label>套餐类型：</label>
                                <span>{{ item.investTypeName }}</span>
                            </li>
                            <li>
                                <label>充值时间：</label>
                                <span>{{ item.createTime }}</span>
                            </li>
                        </ul>
                        <div class="btnOuter">
                            <mt-button type="primary" size="small" class="line-button line-button--mini" @click="rechargeDetail(item)">查看详情</mt-button>
                        </div>         
                    </div>
                    <div class="tips">没有更多了哦</div>
                </div>
                <div v-else class="nodata">
                    <img src="@/assets/nodata.png" alt="">
                    <span>暂无数据</span>
                </div>
            </div>
        </van-tab>


        <!-- <van-tab title="个人账户流水" v-if="$store.state.isHeadquarterAppid=='true'">
            <div class="recordPanel">
                <div v-if="accountFlowList.length > 0">
                    <div v-for="item in accountFlowList" :key="item.id" class="records">
                        
                        <ul class="rechargeInfo">
                            <li>
                                <label>关联单号：</label>
                                <span>{{ item.orderNo }}</span>
                            </li>
                            <li>
                                <label>变动类型：</label>
                                <span v-if="item.flowType == 1" style="color: green;">余额充值 - 入账</span>
                                <span v-if="item.flowType == 2" style="color: red;">流量订购 - 出账</span>
                            </li>
                            <li>
                                <label v-if="item.flowType == 1">充值方式：</label>
                                <label v-if="item.flowType == 2">支付方式：</label>
                                <span v-if="item.orderNo.indexOf('JD') == 0" >京东充值</span>
                                <span v-else-if="item.orderNo.indexOf('WX') == 0" >微信充值</span>
                                <span v-else-if="item.orderNo.indexOf('YE') == 0" >余额支付</span>
                                <span v-else>客服充值</span>
                            </li>
                            <li>
                                <label>变动金额：</label>
                                <span v-if="item.flowType == 1" style="color: green;">+{{money_format(item.amount/100, 2, '.', ',')}}元</span>
                                <span v-if="item.flowType == 2" style="color: red;">-{{money_format(item.amount/100, 2, '.', ',')}}元</span>
                            </li>
                            
                            <li>
                                <label>变动时间：</label>
                                <span>{{ item.createTime }}</span>
                            </li>
                        </ul>     
                    </div>
                    <div class="tips">没有更多了哦</div>
                </div>
                <div v-else class="nodata">
                    <img src="@/assets/nodata.png" alt="">
                    <span>暂无数据</span>
                </div>
            </div>
        </van-tab> -->


    </van-tabs>
</template>
<script>
import {wxRequest} from '@/api/user.js'
export default {
    data(){
        return {
            active: 2,
            balanceRechargeRocordList: [],
            rechargeRocordList: [],
            accountFlowList: [],
        }
    },
    methods: {
        rechargeDetail(item){
            this.$router.push({
                name: 'rechargeDetail',
                query: item
            })
        }
    },
    created(){
        var data = {
            iccid: this.$store.state.iccid,
            mobile: localStorage.getItem('mobile'),
        }
        wxRequest("order/wx/user/investOrder", data, "post").then(res => {
            if(res.data.code == 200){
                this.balanceRechargeRocordList = res.data.data;
            }
        });

        wxRequest("order/pkgOrder/listPage", data, "post").then(res => {
            if(res.data.code == 200){
                this.rechargeRocordList = res.data.data.resultList;
            }
        });

        wxRequest("sysUser/account/querySysUserAccountFlow", data, "post").then(res => {
            if(res.data.code == 200){
                this.accountFlowList = res.data.data;
            }
        });
    }
}
</script>
<style lang="less">
#recordPage{
    .recordPanel {
        min-height: 100%;
        background: #f2f2f2;
        .records {
            margin-bottom: 12px;
            background: #fff;
        }
        h4 {
            display: flex;
            justify-content: space-between;
            padding: 0 4%;
            line-height: 34px;
            .money {
                color: red;
            }
        }
        ul {
            padding: 0 4%;
            border-top: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            li {
                line-height: 28px;
            }
        }
        .btnOuter {
            padding: 0 4%;
            line-height: 34px;
            text-align: right;
        }
        .tips {
            color: #a0a0a0;
            text-align: center;
            line-height: 28px;
        }
        .nodata {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;  
            img {
                width: 14%;
                margin: 10px;
            }   
            span{
                margin-bottom: 10px;
            }   
        }
    }
}

</style>


